import { Component } from "react";
import { Flex } from "@chakra-ui/react";
import { electronOnly } from "src/utils/environment";
import { getIsInDetachMode } from "src/duck/selectors";
import BackButton from "src/components/BackButton";
import CloseButton from "src/atoms/CloseButton";
import { compose } from "recompose";
import { connect } from "react-redux";

import Context from "../Context";

const remote = window.require("@electron/remote");

const FRAME_HEIGHT = 38;
const DETACH_HEIGHT = 0;

const initialState = {
  content: null,
  containerCss: {},
  containerProps: null,
  onBack: null,
  onClose: null,
  isFullScreen: false,
  backButtonProps: null,
  closeButtonProps: null
};

class MacOs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initialState,
      providing: {
        update: (update) => this.setState(update),
        setDefaults: (initialValues) =>
          this.setState(({ isFullScreen }) => ({
            ...initialState,
            ...initialValues,
            isFullScreen
          })),
        height: this.props.isInDetachMode ? DETACH_HEIGHT : FRAME_HEIGHT
      }
    };
  }

  componentDidUpdate() {
    const { providing } = this.state;
    const { isInDetachMode } = this.props;
    if (isInDetachMode && providing.height !== DETACH_HEIGHT) {
      this.setState(({ providing }) => ({
        providing: { ...providing, height: DETACH_HEIGHT }
      }));
    }
    if (!isInDetachMode && providing.height !== FRAME_HEIGHT) {
      this.setState(({ providing }) => ({
        providing: { ...providing, height: FRAME_HEIGHT }
      }));
    }
  }

  componentDidMount() {
    electronOnly(() => {
      const browserWindow = remote.getCurrentWindow();
      if (browserWindow.isFullScreen()) this.handleFullScreenChange();
      browserWindow.on("enter-full-screen", this.handleFullScreenChange);
      browserWindow.on("leave-full-screen", this.handleFullScreenChange);
    });
  }
  componentWillUnmount() {
    electronOnly(() => {
      const browserWindow = remote.getCurrentWindow();
      browserWindow.off("enter-full-screen", this.handleFullScreenChange);
      browserWindow.off("leave-full-screen", this.handleFullScreenChange);
    });
  }
  handleFullScreenChange = () => {
    const browserWindow = remote.getCurrentWindow();
    this.setState({ isFullScreen: browserWindow.isFullScreen() });
  };

  render() {
    const {
      containerCss = {},
      containerProps,
      onBack,
      onClose,
      isFullScreen,
      backButtonProps,
      closeButtonProps
    } = this.state;
    const { isInDetachMode } = this.props;
    return (
      <>
        <Flex
          pl={isFullScreen ? "24px" : "90px"}
          pr="14px"
          alignItems="center"
          width="100vw"
          zIndex={60}
          height={isInDetachMode ? `${DETACH_HEIGHT}px` : `${FRAME_HEIGHT}px`}
          sx={{
            WebkitAppRegion: "drag"
          }}
          {...containerProps}
          {...containerCss}
        >
          {onBack ? <BackButton onClick={onBack} /> : null}
          {backButtonProps ? <BackButton {...backButtonProps} /> : null}
          {this.state.content}
          {onClose ? <CloseButton ml="auto" onClick={onClose} /> : null}
          {closeButtonProps ? (
            <CloseButton ml="auto" {...closeButtonProps} />
          ) : null}
        </Flex>
        <Context.Provider value={this.state.providing}>
          {this.props.children}
        </Context.Provider>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    isInDetachMode: getIsInDetachMode(state)
  };
}

const enhance = compose(connect(mapStateToProps));

export default enhance(MacOs);
